import React from 'react';
import './App.css';
import { variableName } from './variableName';


function Footer() {
    return (
        <>
            <footer className='footer' style={
                {
                    bottom: 0,
                    width: "100%"
                }}>

                <div className='row m-0' style={{
                    fontSize: 18,
                    fontWeight: 700,
                }}>

                    <div className='col-md-5 pl-5 offset-md-1'>
                        <p>

                            {/* {variableName.outer.address.map((addressLine, index) => (
                                <span key={index}>{addressLine}<br /></span>
                                ))} */}
                            <ul style={{ listStyle: "none" }}>
                                <li>
                                    {/* {variableName.outer.footerName} */}
                                </li>
                                <li>UDYAM REGISTRATION NUMBER : UDYAM-MH-15-0118478</li>
                                <li>D.L.No. : 20B/437339, 21B/437340, 20D/437342</li>
                                <li style={{ paddingLeft: "74px" }}>K-21/437338, K-20/437337, K-20C/437341</li>
                                <li>GSTIN : 27ABAFP1524B1ZU</li>
                            </ul>
                        </p>

                    </div>
                    <div className='col-md-6'>
                        <div className='row'>
                            <div className=' col-md-4  '>

                            </div>
                            <div className=' col-md-8'>
                                <div className='row'>
                                    <div className=' col-md-6  '>
                                        <ul style={{ listStyle: "none" }}>
                                            {variableName.outer.right.liContent.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}

                                        </ul>
                                    </div>
                                    <div className=' col-md-6  '>
                                        <ul style={{ listStyle: "none" }}>
                                            {variableName.outer.end.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className='text-center  ' style={{ paddingTop: 10 }}>
                    <p className="m-0" style={{ fontSize: 12 }}>By <a href='https://relysoft.in/' rel="noopener noreferrer" target='_blank'>Reliable Software, Goa</a>. </p>
                </div>
            </footer>
        </>
    )
}
export default Footer;